import http from 'utils/http';
import { getOrganizationsUrl, getAgencyOrganizationsUrl } from './apiUrl';
import { AgencyOrganizationsResponse, OrganizationsResponse } from './types';

export function getOrganizations(): Promise<OrganizationsResponse> {
  return http.get(getOrganizationsUrl());
}

export function getAgencyOrganizations(): Promise<AgencyOrganizationsResponse> {
  return http.get(getAgencyOrganizationsUrl());
}

export function updateOrganizations(payload: OrganizationsResponse | FormData): Promise<OrganizationsResponse> {
  return http.put(getAgencyOrganizationsUrl(), payload);
}
